import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

@customElement('settings-card')
export class SettingsCard extends LitElement {

    @property({ type: String })
    header?: string;

    @property({ type: String })
    maxWidth: string = '50%';

    protected render() {
        return html`
            <div class="settingCard" style="max-width: ${this.maxWidth}">
                <div class="cardTitle">${this.header}
                    <slot name="header"></slot>
                </div>
                <slot></slot>
            </div>
        `;
    }

    static get styles() {
        return css`
            :host {
                flex: 1;
            }

            .settingCard  {
                flex: 1;
                display: flex;
                flex-direction: column;
                font-size: 14px;
                max-width: 100%;
                padding: 1rem;
                border-radius: 0.5rem;
                border: 1px solid var(--theme-border-color);
                box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05),
                    0px 2px 2px -2px rgba(31, 27, 45, 0.08);
                background-color: var(--theme-white-color);
                margin: auto;
                height: calc(100% - 2rem);
            }

            .settingCard  .cardTitle {
                font-size: 0.9rem;
                font-weight: 700;
                text-align: left;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }


            .cardButtons form-button {
                font-size: 1rem;
                font-weight: 500;
            }

            .cardButtons {
                justify-content: center;
            }
        `;
    }
}
